import { Button, Form, Modal } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faCartShopping, faUser, faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { Axios } from "../../../API/Axios";
import { CATEGORIES } from "../../../API/Api";
import StringSlice from "../../../Helpers/StringSlice";
import Skeltonshow from "../sekelton/skelton";
import { useCart } from "../../../Context/CartChangerContext";
import PlusMinusBtn from "../Btns/PlusMinsBut";
import { useLanguage } from "../../../Context/LanguageContext";
import "../../../Css/Storefront.css";

export default function NavBar ()
{
    const { t } = useLanguage();
    const [ category, setCategory ] = useState( [] );
    const [ loading, setLoading ] = useState( true );
    const [ show, setShow ] = useState( false );
    const [ scrolled, setScrolled ] = useState( false );
    const [ mobileSearchOpen, setMobileSearchOpen ] = useState( false );
    const [ searchQuery, setSearchQuery ] = useState( "" );
    const mobileSearchInputRef = useRef( null );
    const navigate = useNavigate();
    const location = useLocation();

    // السلة دلوقتي جايه من الباك اند (خاصة بالمستخدم المسجّل دخوله)، مش من localStorage
    const { cart, updateCartItem, removeFromCart } = useCart();

    const handleClose = () => setShow( false );
    const handleShow = () => setShow( true );

    const submitSearch = () =>
    {
        const query = searchQuery.trim();
        if ( query.length === 0 ) return;
        navigate( `/search?q=${ encodeURIComponent( query ) }` );
        setMobileSearchOpen( false );
    };

    // لو المستخدم مسح كلمة البحث وهو واقف في صفحة نتائج البحث، نرجعه
    // تلقائيًا للصفحة اللي كان فيها قبل كده بدل ما يفضل واقف في نتائج فاضية
    const handleSearchChange = ( value ) =>
    {
        setSearchQuery( value );
        if ( value.trim().length === 0 && location.pathname === "/search" )
        {
            navigate( -1 );
        }
    };

    // لو دخل لصفحة البحث مباشرة من رابط (أو عمل refresh)، نعرض كلمة
    // البحث الحالية في الحقل بدل ما يفضل فاضي
    useEffect( () =>
    {
        if ( location.pathname === "/search" )
        {
            const params = new URLSearchParams( location.search );
            setSearchQuery( params.get( "q" ) || "" );
        }
    }, [ location.pathname, location.search ] );

    useEffect( () =>
    {
        Axios.get( CATEGORIES )
            .then( ( res ) => setCategory( res.data.slice( -13 ) ) )
            .finally( () => setLoading( false ) );
    }, [] );

    // ظل أوضح على الشريط بعد ما المستخدم يبدأ يسكرول، بدل ظل ثابت طول الوقت
    useEffect( () =>
    {
        const onScroll = () => setScrolled( window.scrollY > 8 );
        window.addEventListener( "scroll", onScroll );
        return () => window.removeEventListener( "scroll", onScroll );
    }, [] );

    useEffect( () =>
    {
        if ( mobileSearchOpen ) mobileSearchInputRef.current?.focus();
    }, [ mobileSearchOpen ] );

    const productsShow = cart.map( ( item ) => (
        <div className="cart-line" key={ item.id }>
            <span className="cart-line-remove" onClick={ () => removeFromCart( item.id ) }>
                <FontAwesomeIcon icon={ faXmark } />
            </span>
            <img src={ item.product?.images?.[ 0 ]?.image } alt="" />
            <div className="flex-grow-1">
                <h6 className="mb-1">{ item.product?.title }</h6>
                <p className="m-0 text-truncate text-muted" style={ { fontSize: "13px" } }>{ item.product?.description }</p>
                <div className="d-flex align-items-center justify-content-between mt-2">
                    <div className="d-flex align-items-center gap-2">
                        <span className="price-current">{ item.product?.discount }$</span>
                        { item.product?.price && (
                            <span className="price-original">{ item.product.price }$</span>
                        ) }
                    </div>
                    <PlusMinusBtn
                        id={ item.id }
                        changeCount={ ( id, newCount ) => updateCartItem( id, newCount ) }
                        count={ item.count || 1 }
                        setCount={ () => { } }
                    />
                </div>
            </div>
        </div>
    ) );

    const categoriesShow = category.map( ( cat ) => (
        <NavLink
            key={ cat.id }
            to={ `/category/${ cat.id }` }
            className={ ( { isActive } ) => `category-chip${ isActive ? " category-chip--active" : "" }` }
        >
            { StringSlice( cat.title, 15 ) }
        </NavLink>
    ) );

    return (
        <>
            <Modal show={ show } onHide={ handleClose } centered>
                <Modal.Header closeButton>
                    <Modal.Title>{ t( 'storefrontNav.cartTitle' ) }</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    { cart.length > 0 ? productsShow : (
                        <p className="text-center text-muted my-4">{ t( 'storefrontNav.emptyCart' ) }</p>
                    ) }
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="light" onClick={ handleClose }>{ t( 'storefrontNav.close' ) }</Button>
                    <Button className="border-0" style={ { background: "linear-gradient(135deg,#e8b54a,#c98d2e)", color: "#1a1206", fontWeight: 700 } } onClick={ handleClose }>
                        { t( 'storefrontNav.checkout' ) }
                    </Button>
                </Modal.Footer>
            </Modal>

            <nav className={ `site-navbar ${ scrolled ? "is-scrolled" : "" }` }>
                <Container>
                    <div className="d-flex align-items-center justify-content-between gap-3">
                        <Link to="/" className="site-navbar-logo">
                            <img width="150px" src={ require( "../../../image/website/logo.png" ) } alt="logo" />
                        </Link>

                        <div className="site-search d-none d-md-block">
                            <Form.Control
                                type="search"
                                placeholder={ t( 'storefrontNav.searchPlaceholder' ) }
                                value={ searchQuery }
                                onChange={ ( e ) => handleSearchChange( e.target.value ) }
                                onKeyDown={ ( e ) => e.key === "Enter" && submitSearch() }
                            />
                            <button className="site-search-btn" onClick={ submitSearch } aria-label="submit search">
                                <FontAwesomeIcon icon={ faMagnifyingGlass } />
                            </button>
                        </div>

                        <div className="d-flex align-items-center gap-2">
                            <button
                                type="button"
                                className="nav-icon-btn d-md-none"
                                onClick={ () => setMobileSearchOpen( ( prev ) => !prev ) }
                                aria-label="search"
                            >
                                <FontAwesomeIcon icon={ faMagnifyingGlass } />
                            </button>

                            <span className="nav-icon-btn" onClick={ handleShow } role="button" aria-label="cart">
                                <FontAwesomeIcon icon={ faCartShopping } />
                                { cart.length > 0 && (
                                    <span className="cart-badge" key={ cart.length }>{ cart.length }</span>
                                ) }
                            </span>

                            <Link to="/profile" className="nav-icon-btn d-none d-sm-flex" aria-label="profile">
                                <FontAwesomeIcon icon={ faUser } />
                            </Link>
                        </div>
                    </div>

                    { mobileSearchOpen && (
                        <div className="mobile-search-row d-md-none">
                            <Form.Control
                                ref={ mobileSearchInputRef }
                                type="search"
                                placeholder={ t( 'storefrontNav.searchPlaceholder' ) }
                                value={ searchQuery }
                                onChange={ ( e ) => handleSearchChange( e.target.value ) }
                                onKeyDown={ ( e ) => e.key === "Enter" && submitSearch() }
                            />
                        </div>
                    ) }

                    <div className="category-strip-wrap">
                        <div className="category-strip mt-3">
                            <NavLink
                                to="/websitecategories"
                                className={ ( { isActive } ) => `category-chip category-chip--all${ isActive ? " category-chip--active" : "" }` }
                            >
                                { t( 'storefrontNav.allCategories' ) }
                            </NavLink>
                            { loading ? (
                                <Skeltonshow length="8" height="34px" width="80px" />
                            ) : categoriesShow }
                        </div>
                    </div>
                </Container>
            </nav>
        </>
    );
}
